<template>
  <router-link v-if="isLink" :to="link" tag="div">
    <slot />
  </router-link>
  <div v-else>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    link: {
      required: true
    },
    isLink: {
      required: true
    }
  }
};
</script>

